import $ from "jquery";

if (document.querySelector(".sliderCards")) {

    const cardSliderCards = document.querySelectorAll(".sliderCards");

    cardSliderCards.forEach(cardSlider => {
        $(cardSlider).slick({
            dots: true,
            autoplay: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },]

        });
    });
}